import React, { useState } from "react";
import {
  Box,
  Button,
  FormControl,
  FormLabel,
  Input,
  VStack,
  Text,
  useToast,
  Container,
  useColorModeValue,
  useColorMode,
  Heading,
} from "@chakra-ui/react";
import { useNavigate } from "react-router-dom";
import { authAPI } from "../services";
import { useTranslation } from "react-i18next";
import { PublicNavbar } from "./layout/PublicNavbar";
import { Footer } from "./layout/Footer";

export const ForgotPassword: React.FC = () => {
  const [email, setEmail] = useState("");
  const [isLoading, setIsLoading] = useState(false);
  const borderColor = useColorModeValue("gray.200", "gray.700");
  const inputBg = useColorModeValue("white", "gray.800");
  const bgColor = useColorModeValue("gray.50", "gray.900");
  const navigate = useNavigate();
  const toast = useToast();
  const { t } = useTranslation();
  const { colorMode } = useColorMode();
  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();

    try {
      setIsLoading(true);
      await authAPI.forgotPassword(email);

      toast({
        title: t("auth.resetEmailSent"),
        status: "success",
        duration: 3000,
        isClosable: true,
      });

      navigate("/login");
    } catch (error: any) {
      toast({
        title: t("auth.resetEmailError"),
        description: error.message,
        status: "error",
        duration: 3000,
        isClosable: true,
      });
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <Box minH="100vh" display="flex" flexDirection="column">
      <PublicNavbar />

      <Box flex="1" bg={bgColor} py={20}>
        <Container mt={20} maxW="container.sm">
          <VStack spacing={16} as="form" onSubmit={handleSubmit}>
            <VStack spacing={4} textAlign="center">
              <Heading
                size="2xl"
                fontFamily="Nasalization"
                bgGradient="linear(to-r, brand.primary, brand.secondary)"
                bgClip="text"
              >
                {t("auth.forgotPassword")}
              </Heading>

              <Text
                fontSize="lg"
                color={colorMode === "dark" ? "gray.400" : "gray.600"}
                maxW="2xl"
              >
                {t("auth.forgotPasswordInstructions")}
              </Text>
            </VStack>

            <FormControl
              isRequired
              bg={inputBg}
              p={8}
              borderRadius="xl"
              border="1px"
              borderColor={borderColor}
            >
              <VStack spacing={6}>
                <FormLabel>{t("auth.login.email")}</FormLabel>
                <Input
                  type="email"
                  value={email}
                  onChange={(e) => setEmail(e.target.value)}
                />
                <Button
                  type="submit"
                  colorScheme="blue"
                  size="lg"
                  width="full"
                  isLoading={isLoading}
                >
                  {t("auth.sendResetEmail")}
                </Button>

                <Button
                  variant="ghost"
                  width="full"
                  onClick={() => navigate("/login")}
                >
                  {t("auth.backToLogin")}
                </Button>
              </VStack>
            </FormControl>
          </VStack>
        </Container>
      </Box>
      <Footer />
    </Box>
  );
};
